/**
 * InputSaleItem - Checkbox item for sale configuration forms
 *
 * Checkbox with unique id attribute, used in NFT listing forms.
 * Wrapped in card-purple styled container.
 *
 * @param {Object} props
 * @param {boolean} props.checked - Whether checkbox is checked by default
 * @param {string} props.text - Label text
 * @param {function} props.onChange - Change event handler
 * @param {string|number} props.id - Unique identifier for the checkbox (also used for DOM id)
 * @param {boolean} props.hide - Unused in current implementation
 * @returns {React.ReactElement} Rendered checkbox item
 */
function InputSaleItem({checked, text, onChange, id, hide}) {

    return (
        <li className="list-group-item card-purple px-4 border-0 px-0">
            <div id={"li_" + id} className="form-check form-check-info text-left">
                <input className="form-check-input" type="checkbox" id={id} value=""
                       onChange={onChange} defaultChecked={checked}/>
                <label className="text-light">
                    {text}
                </label>
            </div>
        </li>
    )

}

export default InputSaleItem
